import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Java's BigDecimal scalar */
  BigDecimal: { input: string; output: string };
};

export enum DataSource {
  Cnf = "CNF",
  Cz = "CZ",
  CofId = "CofID",
  Usda = "USDA",
}

export type IFood = {
  __typename: "Food";
  dataSource: DataSource;
  descriptionEn: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  nameEn: Scalars["String"]["output"];
  nutrition: INutrition;
  scientificName: Scalars["String"]["output"];
};

export type IFoodSearchResult = {
  __typename: "FoodSearchResult";
  foods: Array<IFood>;
  userIngredients: Array<IUserIngredient>;
};

export type IIngredientCalculation = {
  __typename: "IngredientCalculation";
  fraction: Scalars["BigDecimal"]["output"];
  ingredient: IRecipeIngredient;
  nutrition: INutrition;
};

export type ILoginResult = {
  __typename: "LoginResult";
  user?: Maybe<IUser>;
};

export type ILoginUserInput = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
};

export type ILogoutResult = {
  __typename: "LogoutResult";
  success: Scalars["Boolean"]["output"];
};

export type IMutation = {
  __typename: "Mutation";
  addRecipeIngredient: IRecipeIngredient;
  createRecipe: IRecipe;
  createUserIngredient: IUserIngredient;
  deleteUserIngredient: Scalars["Boolean"]["output"];
  loginUser: ILoginResult;
  logoutUser: ILogoutResult;
  registerUser: IRegisterResult;
  setVersion: Scalars["String"]["output"];
  updateRecipe: IRecipe;
  updateUserIngredient: IUserIngredient;
};

export type IMutationAddRecipeIngredientArgs = {
  input: INewRecipeIngredientInput;
};

export type IMutationCreateRecipeArgs = {
  input: INewRecipeInput;
};

export type IMutationCreateUserIngredientArgs = {
  input: INewUserIngredientInput;
};

export type IMutationDeleteUserIngredientArgs = {
  input: Scalars["ID"]["input"];
};

export type IMutationLoginUserArgs = {
  input: ILoginUserInput;
};

export type IMutationRegisterUserArgs = {
  input: IRegisterUserInput;
};

export type IMutationUpdateRecipeArgs = {
  input: IUpdateRecipeInput;
};

export type IMutationUpdateUserIngredientArgs = {
  input: IUpdateUserIngredientInput;
};

export type INewRecipeIngredientInput = {
  amount: Scalars["BigDecimal"]["input"];
  recipeId: Scalars["ID"]["input"];
  referenceIngredient?: InputMaybe<IReferenceIngredientInput>;
  userIngredient?: InputMaybe<IUserIngredientInput>;
};

export type INewRecipeInput = {
  description: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type INewUserIngredientInput = {
  carb: Scalars["BigDecimal"]["input"];
  descriptionEn: Scalars["String"]["input"];
  energyKcal: Scalars["BigDecimal"]["input"];
  energyKj: Scalars["BigDecimal"]["input"];
  fatSaturated: Scalars["BigDecimal"]["input"];
  fatTotal: Scalars["BigDecimal"]["input"];
  nameEn: Scalars["String"]["input"];
  protein: Scalars["BigDecimal"]["input"];
  salt: Scalars["BigDecimal"]["input"];
  scientificName: Scalars["String"]["input"];
  sugar: Scalars["BigDecimal"]["input"];
};

export type INutrition = {
  __typename: "Nutrition";
  carb: Scalars["BigDecimal"]["output"];
  energyKcal: Scalars["BigDecimal"]["output"];
  energyKj: Scalars["BigDecimal"]["output"];
  fatSaturated: Scalars["BigDecimal"]["output"];
  fatTotal: Scalars["BigDecimal"]["output"];
  protein: Scalars["BigDecimal"]["output"];
  salt: Scalars["BigDecimal"]["output"];
  sugar: Scalars["BigDecimal"]["output"];
};

export type IQuery = {
  __typename: "Query";
  currentUser?: Maybe<IUser>;
  getRecipe: IRecipe;
  getVersion: Scalars["String"]["output"];
  myRecipies: Array<IRecipe>;
  searchFood: IFoodSearchResult;
};

export type IQueryGetRecipeArgs = {
  id: Scalars["ID"]["input"];
};

export type IQuerySearchFoodArgs = {
  input: ISearchFoodQueryInput;
};

export type IRecipe = {
  __typename: "Recipe";
  calculation: IRecipeCalculation;
  cookedAmount: Scalars["BigDecimal"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  ingredients: Array<IRecipeIngredient>;
  name: Scalars["String"]["output"];
};

export type IRecipeCalculation = {
  __typename: "RecipeCalculation";
  ingredients: Array<IIngredientCalculation>;
  nutritionPer100g: INutrition;
  recipe: IRecipe;
  totalAmount: Scalars["BigDecimal"]["output"];
  yieldFactor: Scalars["BigDecimal"]["output"];
};

export type IRecipeIngredient =
  | IReferenceRecipeIngredient
  | IUserRecipeIngredient;

export type IReferenceIngredientInput = {
  foodId: Scalars["ID"]["input"];
};

export type IReferenceRecipeIngredient = {
  __typename: "ReferenceRecipeIngredient";
  amount: Scalars["BigDecimal"]["output"];
  food: IFood;
  id: Scalars["ID"]["output"];
};

export type IRegisterResult = {
  __typename: "RegisterResult";
  user: IUser;
};

export type IRegisterUserInput = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  passwordRepeat: Scalars["String"]["input"];
};

export type ISearchFoodQueryInput = {
  searchSources?: InputMaybe<Array<SearchSource>>;
  term: Scalars["String"]["input"];
};

export enum SearchSource {
  Cnf = "CNF",
  Cz = "CZ",
  CofId = "CofID",
  Mine = "Mine",
}

export type IUpdateIngredientInput = {
  amount: Scalars["BigDecimal"]["input"];
  ingredientId: Scalars["ID"]["input"];
};

export type IUpdateRecipeInput = {
  cookedAmount: Scalars["BigDecimal"]["input"];
  description: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  ingredients: Array<IUpdateIngredientInput>;
  name: Scalars["String"]["input"];
};

export type IUpdateUserIngredientInput = {
  carb: Scalars["BigDecimal"]["input"];
  descriptionEn: Scalars["String"]["input"];
  energyKcal: Scalars["BigDecimal"]["input"];
  energyKj: Scalars["BigDecimal"]["input"];
  fatSaturated: Scalars["BigDecimal"]["input"];
  fatTotal: Scalars["BigDecimal"]["input"];
  id: Scalars["ID"]["input"];
  nameEn: Scalars["String"]["input"];
  protein: Scalars["BigDecimal"]["input"];
  salt: Scalars["BigDecimal"]["input"];
  scientificName: Scalars["String"]["input"];
  sugar: Scalars["BigDecimal"]["input"];
};

export type IUser = {
  __typename: "User";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type IUserIngredient = {
  __typename: "UserIngredient";
  descriptionEn: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  nameEn: Scalars["String"]["output"];
  nutrition: INutrition;
  scientificName: Scalars["String"]["output"];
};

export type IUserIngredientInput = {
  userIngredientId: Scalars["ID"]["input"];
};

export type IUserRecipeIngredient = {
  __typename: "UserRecipeIngredient";
  amount: Scalars["BigDecimal"]["output"];
  id: Scalars["ID"]["output"];
  userIngredient: IUserIngredient;
};

export type ITestQueryVariables = Exact<{ [key: string]: never }>;

export type ITestQuery = { __typename: "Query"; getVersion: string };

export type INutritionFieldsFragment = {
  __typename: "Nutrition";
  carb: string;
  energyKcal: string;
  energyKj: string;
  fatSaturated: string;
  fatTotal: string;
  protein: string;
  salt: string;
  sugar: string;
};

export type IReferenceRecipeIngredientFieldsFragment = {
  __typename: "ReferenceRecipeIngredient";
  id: string;
  amount: string;
  food: { __typename: "Food" } & IFoodFieldsFragment;
};

export type IUseRecipeIngredientFieldsFragment = {
  __typename: "UserRecipeIngredient";
  id: string;
  amount: string;
  userIngredient: {
    __typename: "UserIngredient";
  } & IUserIngredientFieldsFragment;
};

type IRecipeIngredientFields_ReferenceRecipeIngredient_Fragment = {
  __typename: "ReferenceRecipeIngredient";
} & IReferenceRecipeIngredientFieldsFragment;

type IRecipeIngredientFields_UserRecipeIngredient_Fragment = {
  __typename: "UserRecipeIngredient";
} & IUseRecipeIngredientFieldsFragment;

export type IRecipeIngredientFieldsFragment =
  | IRecipeIngredientFields_ReferenceRecipeIngredient_Fragment
  | IRecipeIngredientFields_UserRecipeIngredient_Fragment;

export type IIngredientCalculationFieldsFragment = {
  __typename: "IngredientCalculation";
  fraction: string;
  nutrition: { __typename: "Nutrition" } & INutritionFieldsFragment;
  ingredient:
    | ({
        __typename: "ReferenceRecipeIngredient";
      } & IRecipeIngredientFields_ReferenceRecipeIngredient_Fragment)
    | ({
        __typename: "UserRecipeIngredient";
      } & IRecipeIngredientFields_UserRecipeIngredient_Fragment);
};

export type IRecipeCalculationFieldsFragment = {
  __typename: "RecipeCalculation";
  totalAmount: string;
  yieldFactor: string;
  ingredients: Array<
    {
      __typename: "IngredientCalculation";
    } & IIngredientCalculationFieldsFragment
  >;
  nutritionPer100g: { __typename: "Nutrition" } & INutritionFieldsFragment;
};

export type IRecipeFieldsFragment = {
  __typename: "Recipe";
  id: string;
  name: string;
  description: string;
  cookedAmount: string;
  ingredients: Array<
    | ({
        __typename: "ReferenceRecipeIngredient";
      } & IRecipeIngredientFields_ReferenceRecipeIngredient_Fragment)
    | ({
        __typename: "UserRecipeIngredient";
      } & IRecipeIngredientFields_UserRecipeIngredient_Fragment)
  >;
  calculation: {
    __typename: "RecipeCalculation";
  } & IRecipeCalculationFieldsFragment;
};

export type ICreateRecipeMutationVariables = Exact<{
  input: INewRecipeInput;
}>;

export type ICreateRecipeMutation = {
  __typename: "Mutation";
  createRecipe: { __typename: "Recipe" } & IRecipeFieldsFragment;
};

export type IUpdateRecipeMutationVariables = Exact<{
  input: IUpdateRecipeInput;
}>;

export type IUpdateRecipeMutation = {
  __typename: "Mutation";
  updateRecipe: { __typename: "Recipe" } & IRecipeFieldsFragment;
};

export type IGetRecipeQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type IGetRecipeQuery = {
  __typename: "Query";
  getRecipe: { __typename: "Recipe" } & IRecipeFieldsFragment;
};

export type IAddRecipeIngredientMutationVariables = Exact<{
  input: INewRecipeIngredientInput;
}>;

export type IAddRecipeIngredientMutation = {
  __typename: "Mutation";
  addRecipeIngredient:
    | ({
        __typename: "ReferenceRecipeIngredient";
      } & IRecipeIngredientFields_ReferenceRecipeIngredient_Fragment)
    | ({
        __typename: "UserRecipeIngredient";
      } & IRecipeIngredientFields_UserRecipeIngredient_Fragment);
};

export type IMyRecipesQueryVariables = Exact<{ [key: string]: never }>;

export type IMyRecipesQuery = {
  __typename: "Query";
  myRecipies: Array<{ __typename: "Recipe" } & IRecipeFieldsFragment>;
};

export type IFoodFieldsFragment = {
  __typename: "Food";
  id: string;
  nameEn: string;
  descriptionEn: string;
  dataSource: DataSource;
  nutrition: { __typename: "Nutrition" } & INutritionFieldsFragment;
};

export type ISearchFoodQueryVariables = Exact<{
  input: ISearchFoodQueryInput;
}>;

export type ISearchFoodQuery = {
  __typename: "Query";
  searchFood: {
    __typename: "FoodSearchResult";
    foods: Array<{ __typename: "Food" } & IFoodFieldsFragment>;
    userIngredients: Array<
      { __typename: "UserIngredient" } & IUserIngredientFieldsFragment
    >;
  };
};

export type IUserFieldsFragment = {
  __typename: "User";
  id: string;
  email: string;
};

export type ICurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type ICurrentUserQuery = {
  __typename: "Query";
  currentUser?: ({ __typename: "User" } & IUserFieldsFragment) | null;
};

export type IRegisterUserMutationVariables = Exact<{
  input: IRegisterUserInput;
}>;

export type IRegisterUserMutation = {
  __typename: "Mutation";
  registerUser: {
    __typename: "RegisterResult";
    user: { __typename: "User" } & IUserFieldsFragment;
  };
};

export type ILoginUserMutationVariables = Exact<{
  input: ILoginUserInput;
}>;

export type ILoginUserMutation = {
  __typename: "Mutation";
  loginUser: {
    __typename: "LoginResult";
    user?: ({ __typename: "User" } & IUserFieldsFragment) | null;
  };
};

export type ILogoutUserMutationVariables = Exact<{ [key: string]: never }>;

export type ILogoutUserMutation = {
  __typename: "Mutation";
  logoutUser: { __typename: "LogoutResult"; success: boolean };
};

export type IUserIngredientFieldsFragment = {
  __typename: "UserIngredient";
  id: string;
  descriptionEn: string;
  nameEn: string;
  scientificName: string;
  nutrition: { __typename: "Nutrition" } & INutritionFieldsFragment;
};

export type ICreateUserIngredientMutationVariables = Exact<{
  input: INewUserIngredientInput;
}>;

export type ICreateUserIngredientMutation = {
  __typename: "Mutation";
  createUserIngredient: {
    __typename: "UserIngredient";
  } & IUserIngredientFieldsFragment;
};

export type IUpdateUserIngredientMutationVariables = Exact<{
  input: IUpdateUserIngredientInput;
}>;

export type IUpdateUserIngredientMutation = {
  __typename: "Mutation";
  updateUserIngredient: {
    __typename: "UserIngredient";
  } & IUserIngredientFieldsFragment;
};

export type IDeleteUserIngredientMutationVariables = Exact<{
  input: Scalars["ID"]["input"];
}>;

export type IDeleteUserIngredientMutation = {
  __typename: "Mutation";
  deleteUserIngredient: boolean;
};

export const NutritionFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment NutritionFields on Nutrition {
    carb
    energyKcal
    energyKj
    fatSaturated
    fatTotal
    protein
    salt
    sugar
  }
`;
export const FoodFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment FoodFields on Food {
    id
    nameEn
    descriptionEn
    dataSource
    nutrition {
      ...NutritionFields
    }
  }
  ${NutritionFieldsFragmentDoc}
`;
export const ReferenceRecipeIngredientFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment ReferenceRecipeIngredientFields on ReferenceRecipeIngredient {
    id
    amount
    food {
      ...FoodFields
    }
  }
  ${FoodFieldsFragmentDoc}
`;
export const UserIngredientFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment UserIngredientFields on UserIngredient {
    id
    descriptionEn
    nameEn
    scientificName
    nutrition {
      ...NutritionFields
    }
  }
  ${NutritionFieldsFragmentDoc}
`;
export const UseRecipeIngredientFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment UseRecipeIngredientFields on UserRecipeIngredient {
    id
    amount
    userIngredient {
      ...UserIngredientFields
    }
  }
  ${UserIngredientFieldsFragmentDoc}
`;
export const RecipeIngredientFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecipeIngredientFields on RecipeIngredient {
    ... on ReferenceRecipeIngredient {
      ...ReferenceRecipeIngredientFields
    }
    ... on UserRecipeIngredient {
      ...UseRecipeIngredientFields
    }
  }
  ${ReferenceRecipeIngredientFieldsFragmentDoc}
  ${UseRecipeIngredientFieldsFragmentDoc}
`;
export const IngredientCalculationFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment IngredientCalculationFields on IngredientCalculation {
    nutrition {
      ...NutritionFields
    }
    ingredient {
      ...RecipeIngredientFields
    }
    fraction
  }
  ${NutritionFieldsFragmentDoc}
  ${RecipeIngredientFieldsFragmentDoc}
`;
export const RecipeCalculationFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecipeCalculationFields on RecipeCalculation {
    ingredients {
      ...IngredientCalculationFields
    }
    totalAmount
    yieldFactor
    nutritionPer100g {
      ...NutritionFields
    }
  }
  ${IngredientCalculationFieldsFragmentDoc}
  ${NutritionFieldsFragmentDoc}
`;
export const RecipeFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecipeFields on Recipe {
    id
    name
    description
    ingredients {
      ...RecipeIngredientFields
    }
    cookedAmount
    calculation {
      ...RecipeCalculationFields
    }
  }
  ${RecipeIngredientFieldsFragmentDoc}
  ${RecipeCalculationFieldsFragmentDoc}
`;
export const UserFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment UserFields on User {
    id
    email
  }
`;
export const TestDocument = /*#__PURE__*/ gql`
  query test {
    getVersion
  }
`;

/**
 * __useTestQuery__
 *
 * To run a query within a React component, call `useTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestQuery(
  baseOptions?: Apollo.QueryHookOptions<ITestQuery, ITestQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ITestQuery, ITestQueryVariables>(
    TestDocument,
    options,
  );
}
export function useTestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ITestQuery, ITestQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ITestQuery, ITestQueryVariables>(
    TestDocument,
    options,
  );
}
export function useTestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ITestQuery, ITestQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ITestQuery, ITestQueryVariables>(
    TestDocument,
    options,
  );
}
export type TestQueryHookResult = ReturnType<typeof useTestQuery>;
export type TestLazyQueryHookResult = ReturnType<typeof useTestLazyQuery>;
export type TestSuspenseQueryHookResult = ReturnType<
  typeof useTestSuspenseQuery
>;
export type TestQueryResult = Apollo.QueryResult<
  ITestQuery,
  ITestQueryVariables
>;
export const CreateRecipeDocument = /*#__PURE__*/ gql`
  mutation CreateRecipe($input: NewRecipeInput!) {
    createRecipe(input: $input) {
      ...RecipeFields
    }
  }
  ${RecipeFieldsFragmentDoc}
`;
export type ICreateRecipeMutationFn = Apollo.MutationFunction<
  ICreateRecipeMutation,
  ICreateRecipeMutationVariables
>;

/**
 * __useCreateRecipeMutation__
 *
 * To run a mutation, you first call `useCreateRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecipeMutation, { data, loading, error }] = useCreateRecipeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRecipeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateRecipeMutation,
    ICreateRecipeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ICreateRecipeMutation,
    ICreateRecipeMutationVariables
  >(CreateRecipeDocument, options);
}
export type CreateRecipeMutationHookResult = ReturnType<
  typeof useCreateRecipeMutation
>;
export type CreateRecipeMutationResult =
  Apollo.MutationResult<ICreateRecipeMutation>;
export type CreateRecipeMutationOptions = Apollo.BaseMutationOptions<
  ICreateRecipeMutation,
  ICreateRecipeMutationVariables
>;
export const UpdateRecipeDocument = /*#__PURE__*/ gql`
  mutation UpdateRecipe($input: UpdateRecipeInput!) {
    updateRecipe(input: $input) {
      ...RecipeFields
    }
  }
  ${RecipeFieldsFragmentDoc}
`;
export type IUpdateRecipeMutationFn = Apollo.MutationFunction<
  IUpdateRecipeMutation,
  IUpdateRecipeMutationVariables
>;

/**
 * __useUpdateRecipeMutation__
 *
 * To run a mutation, you first call `useUpdateRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecipeMutation, { data, loading, error }] = useUpdateRecipeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRecipeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateRecipeMutation,
    IUpdateRecipeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IUpdateRecipeMutation,
    IUpdateRecipeMutationVariables
  >(UpdateRecipeDocument, options);
}
export type UpdateRecipeMutationHookResult = ReturnType<
  typeof useUpdateRecipeMutation
>;
export type UpdateRecipeMutationResult =
  Apollo.MutationResult<IUpdateRecipeMutation>;
export type UpdateRecipeMutationOptions = Apollo.BaseMutationOptions<
  IUpdateRecipeMutation,
  IUpdateRecipeMutationVariables
>;
export const GetRecipeDocument = /*#__PURE__*/ gql`
  query GetRecipe($id: ID!) {
    getRecipe(id: $id) {
      ...RecipeFields
    }
  }
  ${RecipeFieldsFragmentDoc}
`;

/**
 * __useGetRecipeQuery__
 *
 * To run a query within a React component, call `useGetRecipeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRecipeQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetRecipeQuery,
    IGetRecipeQueryVariables
  > &
    (
      | { variables: IGetRecipeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IGetRecipeQuery, IGetRecipeQueryVariables>(
    GetRecipeDocument,
    options,
  );
}
export function useGetRecipeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetRecipeQuery,
    IGetRecipeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IGetRecipeQuery, IGetRecipeQueryVariables>(
    GetRecipeDocument,
    options,
  );
}
export function useGetRecipeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IGetRecipeQuery,
        IGetRecipeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IGetRecipeQuery, IGetRecipeQueryVariables>(
    GetRecipeDocument,
    options,
  );
}
export type GetRecipeQueryHookResult = ReturnType<typeof useGetRecipeQuery>;
export type GetRecipeLazyQueryHookResult = ReturnType<
  typeof useGetRecipeLazyQuery
>;
export type GetRecipeSuspenseQueryHookResult = ReturnType<
  typeof useGetRecipeSuspenseQuery
>;
export type GetRecipeQueryResult = Apollo.QueryResult<
  IGetRecipeQuery,
  IGetRecipeQueryVariables
>;
export const AddRecipeIngredientDocument = /*#__PURE__*/ gql`
  mutation AddRecipeIngredient($input: NewRecipeIngredientInput!) {
    addRecipeIngredient(input: $input) {
      ...RecipeIngredientFields
    }
  }
  ${RecipeIngredientFieldsFragmentDoc}
`;
export type IAddRecipeIngredientMutationFn = Apollo.MutationFunction<
  IAddRecipeIngredientMutation,
  IAddRecipeIngredientMutationVariables
>;

/**
 * __useAddRecipeIngredientMutation__
 *
 * To run a mutation, you first call `useAddRecipeIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRecipeIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRecipeIngredientMutation, { data, loading, error }] = useAddRecipeIngredientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRecipeIngredientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IAddRecipeIngredientMutation,
    IAddRecipeIngredientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IAddRecipeIngredientMutation,
    IAddRecipeIngredientMutationVariables
  >(AddRecipeIngredientDocument, options);
}
export type AddRecipeIngredientMutationHookResult = ReturnType<
  typeof useAddRecipeIngredientMutation
>;
export type AddRecipeIngredientMutationResult =
  Apollo.MutationResult<IAddRecipeIngredientMutation>;
export type AddRecipeIngredientMutationOptions = Apollo.BaseMutationOptions<
  IAddRecipeIngredientMutation,
  IAddRecipeIngredientMutationVariables
>;
export const MyRecipesDocument = /*#__PURE__*/ gql`
  query MyRecipes {
    myRecipies {
      ...RecipeFields
    }
  }
  ${RecipeFieldsFragmentDoc}
`;

/**
 * __useMyRecipesQuery__
 *
 * To run a query within a React component, call `useMyRecipesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRecipesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRecipesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyRecipesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IMyRecipesQuery,
    IMyRecipesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IMyRecipesQuery, IMyRecipesQueryVariables>(
    MyRecipesDocument,
    options,
  );
}
export function useMyRecipesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IMyRecipesQuery,
    IMyRecipesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IMyRecipesQuery, IMyRecipesQueryVariables>(
    MyRecipesDocument,
    options,
  );
}
export function useMyRecipesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IMyRecipesQuery,
        IMyRecipesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IMyRecipesQuery, IMyRecipesQueryVariables>(
    MyRecipesDocument,
    options,
  );
}
export type MyRecipesQueryHookResult = ReturnType<typeof useMyRecipesQuery>;
export type MyRecipesLazyQueryHookResult = ReturnType<
  typeof useMyRecipesLazyQuery
>;
export type MyRecipesSuspenseQueryHookResult = ReturnType<
  typeof useMyRecipesSuspenseQuery
>;
export type MyRecipesQueryResult = Apollo.QueryResult<
  IMyRecipesQuery,
  IMyRecipesQueryVariables
>;
export const SearchFoodQueryDocument = /*#__PURE__*/ gql`
  query SearchFoodQuery($input: SearchFoodQueryInput!) {
    searchFood(input: $input) {
      foods {
        ...FoodFields
      }
      userIngredients {
        ...UserIngredientFields
      }
    }
  }
  ${FoodFieldsFragmentDoc}
  ${UserIngredientFieldsFragmentDoc}
`;

/**
 * __useSearchFoodQuery__
 *
 * To run a query within a React component, call `useSearchFoodQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFoodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFoodQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchFoodQuery(
  baseOptions: Apollo.QueryHookOptions<
    ISearchFoodQuery,
    ISearchFoodQueryVariables
  > &
    (
      | { variables: ISearchFoodQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ISearchFoodQuery, ISearchFoodQueryVariables>(
    SearchFoodQueryDocument,
    options,
  );
}
export function useSearchFoodQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ISearchFoodQuery,
    ISearchFoodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ISearchFoodQuery, ISearchFoodQueryVariables>(
    SearchFoodQueryDocument,
    options,
  );
}
export function useSearchFoodQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ISearchFoodQuery,
        ISearchFoodQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ISearchFoodQuery, ISearchFoodQueryVariables>(
    SearchFoodQueryDocument,
    options,
  );
}
export type SearchFoodQueryHookResult = ReturnType<typeof useSearchFoodQuery>;
export type SearchFoodQueryLazyQueryHookResult = ReturnType<
  typeof useSearchFoodQueryLazyQuery
>;
export type SearchFoodQuerySuspenseQueryHookResult = ReturnType<
  typeof useSearchFoodQuerySuspenseQuery
>;
export type SearchFoodQueryQueryResult = Apollo.QueryResult<
  ISearchFoodQuery,
  ISearchFoodQueryVariables
>;
export const CurrentUserDocument = /*#__PURE__*/ gql`
  query CurrentUser {
    currentUser {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ICurrentUserQuery,
    ICurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ICurrentUserQuery, ICurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
export function useCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICurrentUserQuery,
    ICurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ICurrentUserQuery, ICurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
export function useCurrentUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICurrentUserQuery,
        ICurrentUserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ICurrentUserQuery, ICurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<
  typeof useCurrentUserLazyQuery
>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<
  typeof useCurrentUserSuspenseQuery
>;
export type CurrentUserQueryResult = Apollo.QueryResult<
  ICurrentUserQuery,
  ICurrentUserQueryVariables
>;
export const RegisterUserDocument = /*#__PURE__*/ gql`
  mutation RegisterUser($input: RegisterUserInput!) {
    registerUser(input: $input) {
      user {
        ...UserFields
      }
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type IRegisterUserMutationFn = Apollo.MutationFunction<
  IRegisterUserMutation,
  IRegisterUserMutationVariables
>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IRegisterUserMutation,
    IRegisterUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IRegisterUserMutation,
    IRegisterUserMutationVariables
  >(RegisterUserDocument, options);
}
export type RegisterUserMutationHookResult = ReturnType<
  typeof useRegisterUserMutation
>;
export type RegisterUserMutationResult =
  Apollo.MutationResult<IRegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<
  IRegisterUserMutation,
  IRegisterUserMutationVariables
>;
export const LoginUserDocument = /*#__PURE__*/ gql`
  mutation LoginUser($input: LoginUserInput!) {
    loginUser(input: $input) {
      user {
        ...UserFields
      }
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type ILoginUserMutationFn = Apollo.MutationFunction<
  ILoginUserMutation,
  ILoginUserMutationVariables
>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ILoginUserMutation,
    ILoginUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ILoginUserMutation, ILoginUserMutationVariables>(
    LoginUserDocument,
    options,
  );
}
export type LoginUserMutationHookResult = ReturnType<
  typeof useLoginUserMutation
>;
export type LoginUserMutationResult = Apollo.MutationResult<ILoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<
  ILoginUserMutation,
  ILoginUserMutationVariables
>;
export const LogoutUserDocument = /*#__PURE__*/ gql`
  mutation LogoutUser {
    logoutUser {
      success
    }
  }
`;
export type ILogoutUserMutationFn = Apollo.MutationFunction<
  ILogoutUserMutation,
  ILogoutUserMutationVariables
>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ILogoutUserMutation,
    ILogoutUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ILogoutUserMutation, ILogoutUserMutationVariables>(
    LogoutUserDocument,
    options,
  );
}
export type LogoutUserMutationHookResult = ReturnType<
  typeof useLogoutUserMutation
>;
export type LogoutUserMutationResult =
  Apollo.MutationResult<ILogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<
  ILogoutUserMutation,
  ILogoutUserMutationVariables
>;
export const CreateUserIngredientDocument = /*#__PURE__*/ gql`
  mutation CreateUserIngredient($input: NewUserIngredientInput!) {
    createUserIngredient(input: $input) {
      ...UserIngredientFields
    }
  }
  ${UserIngredientFieldsFragmentDoc}
`;
export type ICreateUserIngredientMutationFn = Apollo.MutationFunction<
  ICreateUserIngredientMutation,
  ICreateUserIngredientMutationVariables
>;

/**
 * __useCreateUserIngredientMutation__
 *
 * To run a mutation, you first call `useCreateUserIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserIngredientMutation, { data, loading, error }] = useCreateUserIngredientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserIngredientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateUserIngredientMutation,
    ICreateUserIngredientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ICreateUserIngredientMutation,
    ICreateUserIngredientMutationVariables
  >(CreateUserIngredientDocument, options);
}
export type CreateUserIngredientMutationHookResult = ReturnType<
  typeof useCreateUserIngredientMutation
>;
export type CreateUserIngredientMutationResult =
  Apollo.MutationResult<ICreateUserIngredientMutation>;
export type CreateUserIngredientMutationOptions = Apollo.BaseMutationOptions<
  ICreateUserIngredientMutation,
  ICreateUserIngredientMutationVariables
>;
export const UpdateUserIngredientDocument = /*#__PURE__*/ gql`
  mutation UpdateUserIngredient($input: UpdateUserIngredientInput!) {
    updateUserIngredient(input: $input) {
      ...UserIngredientFields
    }
  }
  ${UserIngredientFieldsFragmentDoc}
`;
export type IUpdateUserIngredientMutationFn = Apollo.MutationFunction<
  IUpdateUserIngredientMutation,
  IUpdateUserIngredientMutationVariables
>;

/**
 * __useUpdateUserIngredientMutation__
 *
 * To run a mutation, you first call `useUpdateUserIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserIngredientMutation, { data, loading, error }] = useUpdateUserIngredientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserIngredientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateUserIngredientMutation,
    IUpdateUserIngredientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IUpdateUserIngredientMutation,
    IUpdateUserIngredientMutationVariables
  >(UpdateUserIngredientDocument, options);
}
export type UpdateUserIngredientMutationHookResult = ReturnType<
  typeof useUpdateUserIngredientMutation
>;
export type UpdateUserIngredientMutationResult =
  Apollo.MutationResult<IUpdateUserIngredientMutation>;
export type UpdateUserIngredientMutationOptions = Apollo.BaseMutationOptions<
  IUpdateUserIngredientMutation,
  IUpdateUserIngredientMutationVariables
>;
export const DeleteUserIngredientDocument = /*#__PURE__*/ gql`
  mutation DeleteUserIngredient($input: ID!) {
    deleteUserIngredient(input: $input)
  }
`;
export type IDeleteUserIngredientMutationFn = Apollo.MutationFunction<
  IDeleteUserIngredientMutation,
  IDeleteUserIngredientMutationVariables
>;

/**
 * __useDeleteUserIngredientMutation__
 *
 * To run a mutation, you first call `useDeleteUserIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserIngredientMutation, { data, loading, error }] = useDeleteUserIngredientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserIngredientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteUserIngredientMutation,
    IDeleteUserIngredientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IDeleteUserIngredientMutation,
    IDeleteUserIngredientMutationVariables
  >(DeleteUserIngredientDocument, options);
}
export type DeleteUserIngredientMutationHookResult = ReturnType<
  typeof useDeleteUserIngredientMutation
>;
export type DeleteUserIngredientMutationResult =
  Apollo.MutationResult<IDeleteUserIngredientMutation>;
export type DeleteUserIngredientMutationOptions = Apollo.BaseMutationOptions<
  IDeleteUserIngredientMutation,
  IDeleteUserIngredientMutationVariables
>;
